import React from "react"
import { useTranslation } from "react-i18next"
import FilesAndSizeDisplay from "./FilesAndSizeDisplay"
import TransferManageUpload from "./styled/TransferManageUpload"
import FilesSize from "./styled/FilesSize"
import Progress from "./Progress"
import CancelUploadButton from "./CancelUploadButton"
import { useTimelineEventData } from "../TimelineEventDataProvider"

const ConfirmedTransferContent = () => {
  const { t } = useTranslation("generic")
  const {
    files: { fileCount, fileSize },
    progress,
    uploadState: {
      isEncrypted,
      isFinished,
      isCancelled,
      isQueued,
      isUploading,
    },
  } = useTimelineEventData()

  return (
    <div>
      <Progress isFinished={isFinished} {...progress}>
        {isFinished && t("##.Upload.Done")}
        {isCancelled && t("##.Upload.Cancelled")}
        {isQueued && t("##.Upload.Queued")}
      </Progress>
      {(isQueued || isUploading) && <CancelUploadButton />}
      {fileCount > 0 && (
        <TransferManageUpload>
          <FilesSize>
            {isEncrypted && <i className="icon-lock" />}
            <FilesAndSizeDisplay fileCount={fileCount} fileSize={fileSize} />
          </FilesSize>
        </TransferManageUpload>
      )}
    </div>
  )
}

export default ConfirmedTransferContent
